import styled from "@emotion/styled";
import classNames from "classnames";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CardTitle from "../../../components/CardTitle";
import { MainLayout } from "../../../components/Layout";
import styles from "./WisdomPartyBuilding.module.scss";
import dianzixinxi from "../../../images/dianzixinxi.png";
import zhuangbei from "../../../images/zhuangbei.png";
import jieneng from "../../../images/jieneng.png";
import YearPicker from "../../../components/YearPicker";
import { DualAxes } from "@ant-design/plots";
import card2Img from "../../../images/card2.png";
import blueProject from "../../../images/blue-project.png";
import circleImg from "../../../images/circle.png";
import { Funnel, Pie } from "@ant-design/plots";
import { Modal, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import middleImg from "../../../images/middle-box2.png";
import request from "../../../utils/request";
import { Project } from "./Modals/Project";
import DialogItemImg1 from "../../../images/modal-card1.png";
import { Policy } from "./Modals/Policy";
import { setSyntheticTrailingComments } from "typescript";
import { LiveTime } from "../../../components/LiveTime/index";
import EchartLine from "./Charts/Line";
import { SwiperTable } from "../../../components/SwiperTable";
import EchartAgePie from "./Charts/AgePie";
const xueliIcon =
  "data:image/png;base64,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";
const ageIcon =
  "data:image/png;base64,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";

const EconomicDevelopmentLayout = styled.div`
  .leading-industry-wrapper {
    justify-content: space-between;
    padding: 0 60px 0 30px;
    margin-top: 17px;
  }
  .industry-item {
    width: 124px;
    aspect-ratio: 0.7167630057803468;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    color: #fff;
    padding-bottom: 30px;
    font-size: 15px;
  }

  .column-chart1 {
    justify-content: space-between;
    margin-top: 15px;
    padding-right: 40px;
  }

  .query-item {
    align-items: center;
  }
  .chart-box {
    margin: 30px 10px 20px 20px;
  }
  .flex-middle {
    align-items: center;
  }

  .panel {
    margin-top: 27px;
  }

  .panel-box {
    margin: 0 106px;
    justify-content: space-between;
    flex-wrap: wrap;
    &:nth-of-type(2) {
      margin-top: 40px;
    }
    .panel-item {
      flex: 0 0 50%;
      /* width: 138px; */
      height: 80px;
      text-align: center;
      background-image: url(${blueProject});
      background-repeat: no-repeat;
      background-size: 138px 80px;
      background-position: center;
      position: relative;
      margin-bottom: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      /* border: 1px dashed #ddd; */
      &:nth-of-type(3) {
        margin-bottom: 0;
      }
      &:nth-of-type(4) {
        margin-bottom: 0;
      }
      span {
        position: absolute;
        top: -25px;
        font-size: 36px;
        color: #22f2ff;
        left: 0;
        right: 0;
        text-align: center;
        /* transform: translateX(-18px); */
      }
      p {
        margin-top: 20px;
        text-align: center;
        color: #fff;
      }
    }
  }

  .circle-panel {
    justify-content: space-between;
    margin: 0 106px;
    margin-top: 22px;

    .circle-item {
      width: 145px;
      height: 106px;
      background-image: url(${circleImg});
      background-repeat: no-repeat;
      position: relative;

      .label {
        line-height: 116px;
        font-size: 18px;
        color: #fff;
        text-align: center;
      }
      .value {
        position: absolute;
        top: 0px;
        font-size: 40px;
        color: #22f2ff;
        left: 0;
        right: 0;
        text-align: center;
      }
    }
  }
  .loudou {
    margin-top: 15px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .pie-box {
    margin-top: 15px;
  }
  .middle {
    background-image: url(${middleImg});
    height: auto !important;
    background-size: cover;
  }
  .ant-modal .ant-modal-content {
    background-color: transparent;
  }
  .dialog-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
  }
  .dialog-item1 {
    width: 1545px;
    min-height: 447px;
    /* background-size: contain;
    background-image: url(${DialogItemImg1});
    background-repeat: no-repeat; */
  }
  .dialog-item2 {
    width: 1545px;
    min-height: 513px;
    margin-top: 20px;
  }
  .ant-modal-wrap {
    z-index: 99999999999;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-modal-close {
    color: #fff;
    top: 54px;
    right: -40px;
    width: 50px;
    height: 50px;
    .ant-modal-close-x {
      font-size: 30px !important;
    }
  }
  .ant-modal .ant-modal-close:hover {
    color: #fff;
  }
`;

const EconomicDevelopment: React.FC = () => {
  const leadingIndustry = [
    {
      bg: zhuangbei,
      label: "装备制造",
    },
    {
      bg: dianzixinxi,
      label: "电子信息",
    },
    {
      bg: jieneng,
      label: "农副食品加工",
    },
  ];
  // const currentYear = useRef(new Date().getFullYear().toString());
  const [currentYear, setCurrentYear] = useState(
    new Date().getFullYear().toString()
  );
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const projectName = useRef("");
  const [economys, setEconomys] = useState<any[]>([]);
  const [economyInfo, setEconomyInfo] = useState<Record<string, any>>({
    economy: [],
    investment: [],
    funnel: [],
    industrial: [],
    services: [],
  });

  // /screen/Index/economyInfo

  const getEconomyInfo = async (dateStr?: string) => {
    try {
      const res = await request(
        `/screen/Index/economyInfo?years=${dateStr || currentYear}`
      );
      setEconomyInfo(res.data?.data);
    } catch (e) {}
  };

  const getEconomys = async () => {
    try {
      const res = await request(
        `/screen/Index/economy?keys=${projectName.current}`
      );
      setEconomys(res.data?.data || []);
    } catch (e) {}
  };

  useEffect(() => {
    getEconomys();
    getEconomyInfo();
  }, [year]);

  const data = [
    {
      type: "Mon",
      value: 455,
      count: 20,
    },
    {
      type: "Tue",
      value: 766,
      count: 10,
    },
    {
      type: "Wed",
      value: 345,
      count: 50,
    },
    {
      type: "Thu",
      value: 500,
      count: 80,
    },
    {
      type: "Fri",
      value: 200,
      count: 40,
    },
    {
      type: "Sat",
      value: 200,
      count: 20,
    },
    {
      type: "Sun",
      value: 200,
      count: 65,
    },
  ];

  const config: React.ComponentProps<typeof DualAxes> = {
    height: 208,
    data: [data, data],
    xField: "type",
    yField: ["value", "count"],
    legend: {
      itemName: {
        formatter(text) {
          return text === "value" ? "月度" : "累计";
        },
        style: {
          fill: "#fff",
        },
      },
    },
    meta: {
      count: {
        formatter(value) {
          return `${value}亿元`;
        },
      },
    },
    tooltip: {
      formatter(datum) {
        return {
          name: datum.count !== undefined ? "累计" : "月度",
          value: datum.count || datum.value,
        };
      },
    },
    geometryOptions: [
      {
        geometry: "column",
      },
      {
        geometry: "line",
        lineStyle: {
          lineWidth: 2,
        },
      },
    ],
  };

  const {
    economy = [],
    funnel = [],
    investment = [],
    industrial = [],
    services = [],
  } = economyInfo;
  const LeftSider = useMemo(() => {
    return (
      <div>
        <div className="leading-industry">
          <CardTitle title="主导产业" />
          <div className={classNames(styles.flex, "leading-industry-wrapper")}>
            {leadingIndustry.map((item, index) => {
              return (
                <div
                  className="industry-item"
                  key={index}
                  style={{ backgroundImage: `url(${item.bg})` }}
                >
                  {item.label}
                </div>
              );
            })}
          </div>
        </div>

        {economy.length > 0 && (
          <>
            <div className={classNames(styles.flex, "column-chart1")}>
              {economy
                .slice(0, 2)
                .map((item: Record<string, any>, index: number) => {
                  return (
                    <div
                      key={index}
                      style={{ marginLeft: index === 1 ? 5 : 0 }}
                    >
                      <div className={classNames(styles.flex, "query-item")}>
                        <CardTitle
                          titleStyles={{
                            width: 242,
                            height: 47,
                          }}
                          title={item.title}
                        />
                        <YearPicker
                          style={{ marginLeft: 9 }}
                          defaultValue={currentYear}
                          onChange={(e, dateStr) => {
                            setCurrentYear(dateStr);
                            getEconomyInfo(dateStr);
                          }}
                        />
                      </div>
                      <div className="chart-box">
                        {item.categories?.length && (
                          <EchartLine
                            xAxisData={item.categories}
                            lineData={item.line}
                            barData={item.column}
                            legendData={["累计", "月度"]}
                          />
                        )}
                        {/* <DualAxes
                          {...config}
                          data={Array(2).fill(
                            item.categories.map(
                              (subItem: string, subIndex: number) => ({
                                type: subItem,
                                value: item.column[subIndex],
                                count: item.line[subIndex],
                              })
                            )
                          )}
                        /> */}
                      </div>
                    </div>
                  );
                })}
            </div>

            <div className={classNames(styles.flex, "column-chart1")}>
              {economy
                .slice(2)
                .map((item: Record<string, any>, index: number) => {
                  return (
                    <div
                      key={index}
                      style={{ marginLeft: index === 1 ? 5 : 0 }}
                    >
                      <div className={classNames(styles.flex, "query-item")}>
                        <CardTitle
                          titleStyles={{
                            width: 242,
                            height: 47,
                          }}
                          title={item.title}
                        />
                        <YearPicker
                          style={{ marginLeft: 9 }}
                          defaultValue={currentYear}
                          onChange={(e, dateStr) => {
                            setCurrentYear(dateStr);
                            getEconomyInfo(dateStr);
                          }}
                        />
                      </div>
                      <div>
                        {item && (
                          <EchartLine
                            xAxisData={item.categories}
                            lineData={item.line}
                            barData={item.column}
                            legendData={["累计", "月度"]}
                          />
                        )}
                        {/* <DualAxes
                          {...config}
                          data={Array(2).fill(
                            item.categories.map(
                              (subItem: string, subIndex: number) => {
                                return {
                                  type: subItem,
                                  value: item.column[subIndex],
                                  count: item.line[subIndex],
                                };
                              }
                            )
                          )}
                        /> */}
                      </div>
                    </div>
                  );
                })}
            </div>
          </>
        )}
      </div>
    );
  }, [leadingIndustry, economy]);

  const props = {
    leftWidth: `${(834 / 1920) * 100}%`,
    rightWidth: `${(439 / 1920) * 100}%`,
  };

  const FunnelData = [
    {
      stage: "项目线索",
      number: 253,
    },
    {
      stage: "在谈项目",
      number: 151,
    },
    {
      stage: "签约项目",
      number: 80,
    },
  ];
  const FunnelConfig: React.ComponentProps<typeof Funnel> = {
    height: 150,
    data: FunnelData,
    xField: "stage",
    yField: "number",
    shape: "pyramid",
    legend: {
      itemName: {
        style: {
          fill: "#fff",
        },
      },
    },
  };

  const pieData1 = [
    {
      type: "装备制造",
      value: 27,
    },
    {
      type: "电子信息",
      value: 25,
    },
    {
      type: "节能环保",
      value: 18,
    },
    {
      type: "产业名称",
      value: 15,
    },
    {
      type: "产业名称",
      value: 10,
    },
    {
      type: "产业名称",
      value: 10,
    },
  ];

  const pieConfig: React.ComponentProps<typeof Pie> = {
    height: 240,
    appendPadding: 10,
    data: pieData1,
    angleField: "value",
    colorField: "type",
    radius: 0.9,
    label: {
      type: "inner",
      offset: "-30%",
      content: "",
      style: {
        fontSize: 14,
        textAlign: "center",
        color: "#fff",
      },
    },
    interactions: [
      {
        type: "element-active",
      },
    ],
    legend: {
      itemName: {
        style: {
          fill: "#fff",
        },
      },
    },
  };
  const columns: ColumnsType<any> = [
    {
      title: "项目名称",
      dataIndex: "name",
      align: "center",
      render(_v, _) {
        return <span style={{ cursor: "pointer" }}>{_v}</span>;
      },
    },
    {
      title: "签约时间",
      colSpan: 8,
      align: "center",
      dataIndex: "signdate",
    },
  ];
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState("economyDetails");
  const [policyType, setPolicyType] = useState("");
  const parentRef = useRef<any>(null);

  const [currentProject, setCurrentProject] = useState<any>();
  const RightSider = useMemo(() => {
    return (
      <div>
        <CardTitle
          titleStyles={{
            paddingLeft: 65,
          }}
          title="签约项目"
        />

        <div className="common-box">
          <div className={styles.inputWrapper} style={{ marginTop: 18 }}>
            <input
              type="text"
              placeholder="请输入项目名称"
              onChange={(e) => {
                projectName.current = e.target.value;
              }}
            />
            <button
              className={styles.searchBtn}
              onClick={() => {
                getEconomys();
              }}
            >
              搜索
            </button>
          </div>
          <div className={styles.tableBox} style={{ marginTop: 28 }}>
            <SwiperTable
              columns={columns}
              slidesHeight={740}
              slidesPerView={9}
              dataSource={economys || []}
              onClick={(record) => {
                setType("economyDetails");
                // setCurrentProject(1951)
                setCurrentProject(record.id);
                setVisible(true);
              }}
            />
            {/* <Table
              className={styles.table}
              columns={columns}
              dataSource={economys || []}
              pagination={false}
              onRow={(record) => {
                return {
                  onClick: (event) => {
                    setType("economyDetails");
                    setCurrentProject(record.id);
                    setVisible(true);
                  }, // 点击行
                };
              }}
            /> */}
          </div>
        </div>
      </div>
    );
  }, [economys, columns]);
  const typeMap = new Map();
  typeMap.set("年度签约项目数", 1);
  typeMap.set("总投资5亿以上项目数", 2);
  typeMap.set("长三角项目签约数", 3);
  return (
    <EconomicDevelopmentLayout ref={parentRef}>
      <LiveTime />
      <MainLayout {...props} left={LeftSider} right={RightSider}>
        <div className="middle">
          <div className={classNames(styles.flex, "flex-middle")}>
            <CardTitle title="招商看板" />
            <YearPicker
              defaultValue={currentYear}
              style={{ marginLeft: "auto", marginRight: 30 }}
              onChange={(e, dateStr) => {
                setCurrentYear(dateStr);
                getEconomyInfo(dateStr);
              }}
            />
          </div>
          <div className="panel">
            <div className={classNames(styles.flex, "panel-box")}>
              {investment.map((item: Record<string, any>, index: number) => {
                return (
                  <>
                    <div
                      className="panel-item"
                      style={{
                        cursor:
                          typeMap.get(item.title) !== undefined
                            ? "pointer"
                            : "auto",
                      }}
                      key={index}
                      onClick={() => {
                        if (typeMap.get(item.title) !== undefined) {
                          setType("policy");
                          setPolicyType(typeMap.get(item.title));
                          setVisible(true);
                        }
                      }}
                    >
                      <div className="breathe-div">
                        {/* <img src={blueProject} alt="" /> */}
                      </div>
                      <span>{item.val}</span>
                      <p>{item.title}</p>
                    </div>
                  </>
                );
              })}
            </div>

            <div className={classNames(styles.flex, "panel-box")}>
              {funnel.map((item: Record<string, any>, index: number) => {
                return (
                  <div className="panel-item" key={index}>
                    <div className="breathe-div">
                      {/* <img src={blueProject} alt="" /> */}
                    </div>
                    <span>{item.value}</span>
                    <p>{item.name}</p>
                    {/* <div className="label">{item.name}</div>
                    <div className="value">{item.value}</div> */}
                  </div>
                );
              })}
            </div>

            <div className="loudou">
              {funnel?.length > 0 && (
                <Funnel
                  {...FunnelConfig}
                  data={funnel?.map((item: any) => {
                    return {
                      stage: item.name,
                      number: item.value,
                    };
                  })}
                />
              )}
            </div>
          </div>

          <div className={classNames(styles.flex, "pie-box")}>
            <div className={styles.flex1}>
              <CardTitle title="招商项目产业分布" />
              {industrial?.length ? (
                <EchartAgePie
                  // pieIcon={ageIcon}
                  imageIndex={0}
                  colorIndex={4}
                  dataOptions={industrial.map((item: any) => {
                    return {
                      name: item.name,
                      value: item.value,
                    };
                  })}
                />
              ) : null}
              {/* <Pie
                {...pieConfig}
                data={industrial.map((item: Record<string, any>) => {
                  return {
                    type: item.name,
                    value: item.value,
                  };
                })}
              /> */}
            </div>
          </div>
        </div>
      </MainLayout>
      <Modal
        style={{ zIndex: 10000 }}
        open={visible}
        getContainer={() => {
          // return null;
          return parentRef.current!;
        }}
        width={1545}
        onCancel={() => {
          setVisible(false);
        }}
      >
        <div className="dialog-item dialog-item1">
          {/* <ProjectModel id={currentProject} /> */}
          {type === "economyDetails" && (
            <Project id={currentProject} type={"economyDetails"} />
          )}
          {type === "policy" && (
            <Policy
              id={policyType}
              policyType={"getProjectList"}
              date={year}
              onRow={(item) => {
                return {
                  onClick: () => {
                    setType("economyDetails");
                    setCurrentProject(item.id);
                    setVisible(true);
                  },
                };
              }}
            />
          )}
        </div>
        {/* {modalContent} */}
        {/* 22222 */}
      </Modal>
    </EconomicDevelopmentLayout>
  );
};

export default EconomicDevelopment;
